import { IframeHTMLAttributes, useState } from 'react'
import { createPortal } from 'react-dom'

interface CustomIFrameProps extends IframeHTMLAttributes<HTMLIFrameElement> {
    children: JSX.Element
}

const CustomIframe = ({ children, ...props }: CustomIFrameProps) => {
    const [contentRef, setContentRef] = useState<any>(null)
    const [iframeBody, setIframeBody] = useState(null)

    // Chrome works with this iframe content solution by default
    const mountNode = contentRef?.contentWindow?.document?.body
    // Fix for Firefox blocking iframe content https://github.com/ianstormtaylor/slate/pull/4758
    const handleLoad = (e: any) => {
        if (iframeBody) {
            return
        }
        if (!e.target.contentDocument) {
            return
        }

        setIframeBody(e.target.contentDocument.body)
    }

    return (
        <iframe
            {...props}
            ref={setContentRef}
            onLoad={handleLoad}
            width={'100%'}
            height={530}
            frameBorder={0}
            name={'card-link-iframe'}
            title={'Card Linking Form'}
        >
            {(mountNode || iframeBody) && createPortal(children, mountNode)}
        </iframe>
    )
}

export default CustomIframe
